<template>
  <div class="block" ref="incomeBlock">
    <div class="block-title left">
      <h3>
        <span class="title">Возврат выручки </span>
        <span v-if="advanceCheque.length">
          <span v-if="refundableAmount > 0">({{ refundableAmount }} &#8381;)</span>
          <i v-else><font-awesome-icon icon="fa-solid fa-spinner" class="fa-spin" /></i>
        </span>
      </h3>
      <i
        class="icon-tooltip"
        v-tooltip.top-center="{
          content:
            'Денежная сумма, полученная курьером у получателя за груз будет переведена Вам выбранным способом.',
          trigger: 'click hover',
        }"
      ></i>
    </div>
    <div class="pay-type">
      <label v-for="method in methodsList" :key="method.value" :for="method.label">
        <input
          type="radio"
          :value="method.value"
          :id="method.label"
          name="pay-type"
          v-model="returnMethod"
        />
        <span>{{
          +method.value === 3
            ? `${method.label} ${
                totalItemsPrice * 0.02 >= 50 ? ' (2% от суммарной ценности грузов)' : ''
              }`
            : method.label
        }}</span>
        <i
          class="icon-tooltip"
          v-tooltip.top-center="{
            content: `При доставке курьер выбивает кассовый чек и передает покупателю заказ. ${
              user.isLegalEntity ? '' : 'Услуга доступна только для юр.лиц.'
            }`,
            trigger: 'hover click',
          }"
          v-if="+method.value === 3"
        ></i>
        <i
          class="icon-tooltip"
          v-tooltip.top-center="{
            content: 'Заказчик берёт на себя обязанность самостоятельно выдать чек получателю.',
            trigger: 'hover click',
          }"
          v-if="+method.value === 0 && user.isLegalEntity"
        ></i>
      </label>
    </div>
    <IncomeReturnCardNumberInput
        v-if="placeholderValue"
        :class-name="getErrorClass('cardNumber')"
        :placeholder="placeholderValue"
        :error-messages="getErrorMessages('cardNumber')"
        @blur="touchField('cardNumber')"
        :suggestion="lastWalletValue"
        v-model.trim="cardNumber"
    />
  </div>
</template>

<script>
import incomeReturnMixins from '@apps/order-form/src/mixins/incomeReturn'
import IncomeReturnCardNumberInput from './IncomeReturnCardNumberInput.vue'

export default {
  name: 'IncomeReturnMethod',
  components: {
    IncomeReturnCardNumberInput,
  },
  mixins: [incomeReturnMixins],
}
</script>

<style lang="scss" scoped>
@import 'https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.css';

.icon-tooltip {
  transform: translateY(10%);
}

h3 {
  font-size: inherit;
}

.block-title {
  display: flex;
  align-items: center;

  i {
    font-size: 18px;
  }
}

.title {
  display: inline-block;

  margin-right: 5px;
}

.label {
  @media (min-width: 768px) {
    max-width: 60%;
  }
}

.disabled {
  cursor: default !important;

  opacity: 0.5;
}
</style>
